import { 
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverBody
} from '@chakra-ui/react';
import classes from './FavPopOver.module.scss';

const FavPopover = ({ isOpen, onClose, onConfirm, isFav, onButtonClick, buttonClass }) => {
    return (
        <>
            {isOpen && <div className={classes.popoverOverlay} onClick={(e) => {
                e.stopPropagation();
                onClose(e);
            }}></div>}
            <Popover
                isOpen={isOpen}
                onClose={(e) => onClose(e)}
                placement="top"
            >
                <PopoverTrigger>
                    <button 
                        onClick={onButtonClick}
                        className={buttonClass}
                    >
                        {!isFav ? 'Favorite' : 'Favorited'}
                    </button>
                </PopoverTrigger>
                <PopoverContent className={classes.popoverContent} onClick={(e) => e.stopPropagation()}>
                    <PopoverBody>
                        <div className={classes.popoverBody}>
                            <p>Remove from favorites?</p>
                            <div className={classes.buttonGroup}>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onConfirm(false, e);
                                    }}
                                    className={classes.noButton}
                                >
                                    No
                                </button>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onConfirm(true, e);
                                    }}
                                    className={classes.yesButton}
                                >
                                    Yes
                                </button>
                            </div>
                        </div>
                    </PopoverBody>
                </PopoverContent>
            </Popover>
        </>
    );
};

export default FavPopover;